import React, { useContext } from "react";
import { ProductOrderSortTypes } from "../../../configs/sortTypes";
import { ProductOrderFilterType } from "../../../configs/filterTypes";
import ListView from "../../../shared/components/ListView";
import { TableColumns } from "../../../configs/productOrder";
import { ProductOrderRow } from "./ProductOrderTable";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const Content = () => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const getTableColumns = () => {
        switch (role) {
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
                return TableColumns.filter((item) => item.text !== "Giá");
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.LOGISTIC_MANAGER:
                return TableColumns;
            default:
                return [];
        }
    };

    return (
        <ListView
            url="/product-flow/v2/orders/"
            sortTypes={ProductOrderSortTypes}
            filterTypes={ProductOrderFilterType}
            rowElement={ProductOrderRow}
            tableColumns={getTableColumns()}
        />
    );
};

export default Content;
